import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStateDeclined = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "m5 6.415 2.83 2.828L9.243 7.83 6.415 5l2.828-2.829L7.83.758 5 3.586 2.172.758.758 2.172l2.828 2.829L.758 7.829l1.414 1.414 2.829-2.828z",
		fill: "#E00751"
	})
});
export default SvgStateDeclined;
